export enum GlobalEventType {
  ToastNotification = 'toast-notification',
}
